import heroGestorTx from "../../assets/images/carrossel/hero-gestor-tx.png";
import heroSolucoes from "../../assets/images/carrossel/hero-solucoes.png";
import heroSeguranca from "../../assets/images/carrossel/hero-seguranca.png";

export const slides = [
    {
        title: "Gestor TX",
        subtitle:
            "SaaS completo para gestão de turmas, alunos e cobranças. Controle total do seu negócio em um único sistema online.",
        image: heroGestorTx,
        background: "linear-gradient(135deg, #E0F7FA, #80DEEA)", // azul claro e ciano
        ctaText: "Conheça agora",
        ctaLink: "https://gestortx.com",
    },
    {
        title: "Soluções Personalizadas",
        subtitle:
            "Desenvolvemos sistemas SaaS sob medida para atender às necessidades do seu negócio com qualidade e inovação.",
        image: heroSolucoes,
        background: "linear-gradient(135deg, #F1F8E9, #AED581)", // verde suave
        ctaText: "Solicitar proposta",
        ctaLink: "/#contato",
    },
    {
        title: "Segurança e Qualidade",
        subtitle:
            "Aplicações seguras, performáticas e com suporte técnico especializado para garantir o sucesso do seu projeto.",
        image: heroSeguranca,
        background: "linear-gradient(135deg, #FFF3E0, #FFB74D)", // laranja suave
        ctaText: "Saiba mais",
        ctaLink: "/#sobre",
    },
];
